export class AuthenticationRequest {

    codigoRecope: string;
    username: string;
    password: string;

    // (gberrocal 2022-08-16) Se agrega la versión del app para el control de acceso por versiones (se utiliza el mismo para web)
    appVersion: string;
}